import {
    ADD_NOISE,
    RESET_NOISE
} from '../../actions/noise'

const initialState = {
    value:[],
    time:[]
}

const noise = (state = initialState, action) => {

    switch (action.type) {
        case ADD_NOISE:
            if (state.value.length === 30) {
                state.value.shift()
                state.time.shift()

            }
            return {
                value: [
                    ...state.value,
                    action.noise.value
                ],
                time: [
                    ...state.time,
                    parseInt(action.noise.time,10)
                ]
            }
        case RESET_NOISE:
            return initialState



        default:
            return state
    }
}

export default noise



// WEBPACK FOOTER //
// ./src/reducers/map/noise.js